import { render, staticRenderFns } from "./RROrderFormDetails.vue?vue&type=template&id=78803010&scoped=true&"
import script from "./RROrderFormDetails.vue?vue&type=script&lang=js&"
export * from "./RROrderFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./RROrderFormDetails.vue?vue&type=style&index=0&id=78803010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78803010",
  null
  
)

export default component.exports